import { ref as v, computed as g, unref as k, watch as C, inject as _ } from "vue";
var N = 5, O = function(e, t) {
  return Promise.resolve(e.amountStarted < t.length);
}, z = { maxInProgress: N, failFast: !1, nextCheck: O, ignoreIsFunctionCheck: !1 };
function j(e, t) {
  return new Promise(function(n, s) {
    var o = Object.assign({}, z, t), i = { amountDone: 0, amountStarted: 0, amountResolved: 0, amountRejected: 0, amountNextCheckFalsey: 0, rejectedIndexes: [], resolvedIndexes: [], nextCheckFalseyIndexes: [], taskResults: [] };
    if (e.length === 0) return n(i);
    for (var r = !1, a = 0, u = function() {
      if (r !== !0) {
        if (i.amountDone++, typeof o.progressCallback == "function" && o.progressCallback(i), i.amountDone === e.length) return n(i);
        a < e.length && c(a++);
      }
    }, c = function(l) {
      o.nextCheck(i, e).then(function(m) {
        m === !0 ? function(f) {
          if (i.amountStarted++, typeof e[f] == "function") e[f]().then(function(p) {
            i.taskResults[f] = p, i.resolvedIndexes.push(f), i.amountResolved++, u();
          }, function(p) {
            if (i.taskResults[f] = p, i.rejectedIndexes.push(f), i.amountRejected++, o.failFast === !0) return r = !0, s(i);
            u();
          });
          else {
            if (o.ignoreIsFunctionCheck !== !0) return r = !0, s(new Error("tasks[" + f + "]: " + e[f] + ", is supposed to be of type function"));
            i.taskResults[f] = e[f], i.resolvedIndexes.push(f), i.amountResolved++, u();
          }
        }(l) : (i.amountNextCheckFalsey++, i.nextCheckFalseyIndexes.push(l), u());
      }, s);
    }, d = 0; d < Math.min(o.maxInProgress, e.length); d++) c(a++);
  });
}
function L(e, t) {
  return new Promise(function(n, s) {
    j(e, t).then(function(o) {
      n(o.taskResults);
    }, function(o) {
      o instanceof Error ? s(o) : s(o.taskResults[o.rejectedIndexes[0]]);
    });
  });
}
function G(e, t) {
  return L(e, Object.assign({}, { failFast: !0 }, t));
}
const T = 5 * 1024 * 1024, $ = 3;
function W(e) {
  const t = Math.ceil(e.size / T), n = [];
  for (let s = 0; s < t; s += 1) {
    const o = s * T, i = Math.min(o + T, e.size);
    n.push({
      file: e,
      partNumber: s + 1,
      getSlice: () => e.slice(o, i, e.type)
    });
  }
  return n;
}
function Ce(e, t) {
  const n = v("IDLE"), s = v(0), o = v(0), i = v(null), r = async (c, d, l) => {
    const m = await e.getSignedUrl("ticket", {
      key: c,
      uploadId: d,
      contentType: l.file.type,
      partNumber: l.partNumber
    });
    o.value += 1;
    const f = await fetch(m, {
      method: "PUT",
      body: l.getSlice()
    });
    return o.value += 1, f.headers.get("etag") ?? "";
  }, a = async (c, d) => {
    try {
      n.value = "IN_PROGRESS";
      const l = W(c);
      s.value = 2 + l.length * 2;
      const m = await e.start("ticket", t, {
        contentType: c.type,
        contentDisposition: `attachment; filename="${c.name}"`
      });
      o.value += 1;
      const { key: f } = m, { uploadId: p } = m, h = l.map(
        (S) => () => r(f, p, S)
      ), y = await G(h, {
        maxInProgress: $,
        failFast: !0
      }), b = await e.stop("ticket", t, {
        key: f,
        uploadId: p,
        contentType: c.type,
        parts: y,
        category: d,
        originalFilename: c.name
      });
      o.value += 1, n.value = "SUCCESS", i.value = b.file;
    } catch (l) {
      console.error(`Could not upload file '${c.name}'`, l), n.value = "ERROR";
    }
  }, u = g(
    () => s.value ? o.value / s.value : 0
  );
  return { upload: a, status: n, progress: u, result: i };
}
function Te(e, t, n = 18) {
  const s = v(0), o = v(1), i = v(295), r = {
    style: "HorizontalDefault",
    minWidth: 295,
    maxWidth: 445
  }, a = g(
    () => {
      var d;
      return ((d = t == null ? void 0 : t.product) == null ? void 0 : d.ticketCard) ?? r;
    }
  );
  s.value = e.clientWidth, o.value = Math.floor(
    s.value / a.value.minWidth
  ) || 1;
  const u = o.value - 1, c = (s.value - u * n) / o.value;
  return c < a.value.maxWidth ? i.value = c : i.value = a.value.maxWidth, { elementWidth: s, cardsPerRow: o, cardWidth: i };
}
function Ee() {
  return { getUserReference: (n) => {
    const s = n.split(":");
    if (s.length !== 4) {
      console.warn(
        "Malformed canonical string. Expected format: context:entity:key:value"
      );
      return;
    }
    const [o, i, r, a] = s;
    if (i !== "user") {
      console.warn(`Unsupported entity: ${i}. Only 'user' is supported.`);
      return;
    }
    if (!o || !r || !a) {
      console.warn("Missing context, key, or value in the canonical string.");
      return;
    }
    return {
      context: o,
      entity: i,
      key: r,
      value: a
    };
  }, referenceToCanonical: (n) => {
    const { context: s, entity: o, key: i, value: r } = n;
    if (!s || !o || !i || !r) {
      console.warn(
        "Incomplete reference. Expected all fields to be non-empty."
      );
      return;
    }
    return `${s}:${o}:${i}:${r}`;
  } };
}
function F(e, t) {
  return t.reduce((n, s) => (n == null ? void 0 : n[s]) ?? null, e);
}
function q(e, t) {
  const n = /* @__PURE__ */ new Map();
  for (const s of e) {
    const o = F(s, t);
    typeof o != "string" ? console.warn("Data grouping must use 'string' values", { groupKey: o }) : n.has(o) ? n.get(o).push(s) : n.set(o, [s]);
  }
  return n;
}
function Fe(e, t, n) {
  const s = k(n), o = g(() => {
    const a = q(k(e), k(t));
    return s.reduce((u, c) => (u[c] = a.get(c) ?? [], u), {});
  }), i = g(() => s), r = g(
    () => s.filter((a) => {
      var u;
      return ((u = o.value[a]) == null ? void 0 : u.length) > 0;
    })
  );
  return { groupedData: o, groups: i, nonEmptyGroups: r };
}
function Be(e) {
  const t = v((e == null ? void 0 : e.field) ?? ""), n = v((e == null ? void 0 : e.direction) ?? ""), s = g(() => {
    if (!(!t.value || !n.value))
      return {
        field: t.value,
        direction: n.value
      };
  }), o = () => {
    n.value === "ASC" ? n.value = "DESC" : n.value === "DESC" ? n.value = "" : n.value = "ASC";
  };
  return { sortStatus: s, toggleSort: (r) => {
    t.value === r ? o() : (t.value = r, n.value = "ASC");
  } };
}
function Ie(e, t) {
  const n = v(e), s = v(t), o = g(() => n.value.length), i = g(
    () => s.value.reduce((d, l) => {
      const m = n.value.some((f) => f.id === l) ? 1 : 0;
      return d + m;
    }, 0)
  ), r = g(() => i.value === 0 ? "no" : n.value.some((d) => !s.value.includes(d.id)) ? "partial" : "yes");
  return {
    countFound: o,
    countSelected: i,
    selection: s,
    selectionStatus: r,
    itemStatus: (d) => s.value.includes(d) ? "yes" : "no",
    toggleAll: () => {
      r.value === "yes" ? s.value = [] : s.value = n.value.map((d) => d.id);
    },
    toggleItem: (d) => {
      if (s.value === void 0) {
        console.warn("Error selecting item, no selection array provided");
        return;
      }
      const l = s.value.indexOf(d);
      if (l === -1)
        s.value = [d, ...s.value];
      else {
        const m = [...s.value];
        m.splice(l, 1), s.value = m;
      }
    }
  };
}
function Ae(e, t) {
  return {
    sorted: g(() => [...e.value].sort((o, i) => {
      const r = t.value.direction === "ASC", a = F(r ? o : i, [t.value.field]), u = F(r ? i : o, [t.value.field]), c = typeof a, d = typeof u;
      return c === "undefined" && d === "undefined" ? 0 : c === "undefined" ? Number.MIN_SAFE_INTEGER : d === "undefined" ? Number.MAX_SAFE_INTEGER : c === "number" && d === "number" ? a - u : c === "string" && d === "string" ? a.localeCompare(u) : c === "boolean" && d === "boolean" ? a - u : (console.warn(
        `Cannot sort by ${t.value.field}, field type unsupported`,
        { a: o, b: i }
      ), 0);
    }))
  };
}
function Re() {
  const e = v("single"), t = v(""), n = v([]), s = v([]), o = (r) => {
    s.value = [r].filter(Boolean);
  }, i = (r) => {
    s.value = r;
  };
  return C(s, (r) => {
    e.value === "single" && r.length > 1 && console.warn(
      "Dropdown configured as a single input cannot receive multiple values. Only first element will be considered"
    ), t.value = (r == null ? void 0 : r[0]) ?? "", n.value = r ?? [];
  }), {
    selectionMode: e,
    modelSingle: t,
    modelMultiple: n,
    model: s,
    updateSingle: o,
    updateMultiple: i
  };
}
function De(e) {
  const t = (o, i) => i.map((r) => {
    const a = r.required && !o;
    switch (r.type) {
      case "assignTo":
        return { ...r, ref: "ticket.assignee", required: a };
      case "delegateTo":
        const u = r.ref.startsWith("ticket.delegate.") ? r.ref : `ticket.delegate.${r.ref}`;
        return { ...r, ref: u, required: a };
      case "tasks":
        return { ...r, ref: `ticket.${r.ref}`, required: a };
      case "taskGroup":
        return { ...r, ref: `ticket.${r.ref}`, required: a };
      case "ticketSkills":
        return { ...r, ref: `ticket.${r.ref}`, required: a };
      case "files":
        return { ...r, required: !1, ref: `ticket.files.${r.ref}` };
      default:
        return { ...r, required: a };
    }
  }), n = g(() => e.map((o) => ({
    groupId: o.groupId,
    groupLabel: o.groupLabel,
    groupIcon: o.groupIcon,
    options: o.options,
    fields: t(o.groupId, o.fields),
    resources: o.resources
  })).filter((o) => o.fields.length));
  return { dynamicForm: g(() => ({
    groups: n.value
  })) };
}
function xe(e, t, n, s) {
  var i;
  const o = (i = t(e.resources ?? {})) == null ? void 0 : i.detail;
  n(o ?? s("error.general").toString());
}
function Me() {
  const e = _("maxFileUploadSize", 52428800), t = g(
    () => (
      // Default 50MB
      e ?? 52428800
    )
  ), n = (i) => {
    const r = ["Bytes", "KB", "MB", "GB", "TB"];
    if (i === 0) return "0 Byte";
    const a = Math.floor(Math.log(i) / Math.log(1024));
    return `${parseFloat((i / 1024 ** a).toFixed(2))} ${r[a]}`;
  }, s = g(
    () => n(t.value)
  );
  return {
    allowFileSize: (i) => !t.value || i.size <= t.value,
    bytesToReadableValue: n,
    maxFileUploadSize: t,
    readableMaxFileUploadSize: s
  };
}
function Pe(e, t, n) {
  const s = g(
    () => n.includes("ADMIN_TICKET_USER_FIELD_LIST")
  ), o = g(
    () => t.value && s.value ? k(t) : k(e)
  ), i = (u, c) => {
    var d;
    return o.value ? (d = o.value) != null && d.audience ? n.includes(c) : n.includes(u) : !1;
  }, r = g(
    () => i("USER_TICKET_USER_FIELD_LIST", "ADMIN_TICKET_USER_FIELD_LIST")
  ), a = g(
    () => i(
      "USER_TICKET_USER_FIELD_WRITE_OWN",
      "ADMIN_TICKET_USER_FIELD_WRITE_OWN"
    )
  );
  return {
    firstCitizen: o,
    hasFirstCitizenReadPermission: r,
    hasFirstCitizenWritePermission: a
  };
}
const K = /{\s*[\w.]+\s*}/g, V = /{{\s*[\w.]+\s*}}/g, x = /[\w.]+/;
function X(e, t) {
  const n = e.split(".");
  let s = t;
  for (const o of n)
    if (s = s[o], !s)
      return;
  return s;
}
function we(e, t) {
  const s = { mustache: "double", ...t }.mustache === "single" ? K : V, o = e.match(s) ?? [];
  return { replace: (a) => {
    let u = e;
    return o.forEach((c) => {
      var m;
      const d = (m = c == null ? void 0 : c.match(x)) == null ? void 0 : m[0], l = d ? a[d] : void 0;
      l !== void 0 && (u = u.replace(c, l));
    }), u;
  }, replaceNested: (a) => {
    let u = e;
    return o.forEach((c) => {
      var m;
      const d = (m = c == null ? void 0 : c.match(x)) == null ? void 0 : m[0], l = d ? X(d, a) : void 0;
      l !== void 0 && typeof l == "string" && (u = u.replace(c, l));
    }), u;
  } };
}
function Ue(e, t) {
  const n = g(() => e.value.filter((r) => !r.groupKey)), s = g(
    () => t.value.filter((r) => e.value.find((a) => a.groupKey === r.key))
  ), o = g(() => s.value.length > 0);
  return { ungrouped: n, nonEmptyGroups: s, hasGroups: o, groupedItems: (r) => e.value.filter((a) => a.groupKey === r.key) };
}
function _e(e, t = ["main"]) {
  const s = e.enabledProducts.map((a) => ({
    productId: a,
    productType: "main",
    customization: e.productCustomization[a]
  })).filter(
    (a) => t.includes(a.productType)
  ), o = g(() => s), i = g(() => s.map((a) => a.productId));
  return { productsData: o, productIds: i, _allProductIds: () => (console.log("[DEPRECATED] _allProductIds"), [
    ...i.value,
    "task",
    "feedback",
    "service_order",
    "campaign"
  ]) };
}
function Ne(e) {
  var o, i, r;
  const t = (o = e.product) == null ? void 0 : o.icons, n = (i = e.product) == null ? void 0 : i.resources, s = (r = e.product) == null ? void 0 : r.ticketCard;
  return t || console.error("workflow.product?.icons cannot be empty"), n || console.error("workflow.product?.resources cannot be empty"), s || console.error("workflow.product?.ticketCard cannot be empty"), { resources: n, icons: t, ticketCard: s };
}
function Oe(e, t) {
  var o, i;
  const n = (i = (o = e == null ? void 0 : e.site) == null ? void 0 : o[t]) == null ? void 0 : i.views;
  function s(r) {
    return n == null ? void 0 : n[r];
  }
  return { page: s };
}
function P(e, t) {
  const n = (r) => r.roles ? r.roles.some(
    (a) => {
      var u;
      return (u = t.userRoles) == null ? void 0 : u.includes(a);
    }
  ) : !0, s = (r) => r.actions ? r.actions.every(
    (a) => {
      var u;
      return (u = t.userActions) == null ? void 0 : u.includes(a);
    }
  ) : !0, o = (r) => !!(!r.actor || r.actor.includes("creator") && t.userId === t.creatorId || r.actor.includes("assignee") && t.userId === t.assigneeId);
  return {
    accessGranted: !e.length || e.some(
      (r) => n(r) && s(r) && o(r)
    ),
    checkActionAccess: s,
    checkActorAccess: o,
    checkRoleAccess: n
  };
}
function w(e, t, n) {
  const s = t.settings[n];
  if (!s) {
    console.warn(`Could not find ${n} '${e}'`);
    return;
  }
  return n === "phases" ? s.find(
    (o) => e === o.name
  ) : s == null ? void 0 : s[e];
}
function Z(e, t, n = "status") {
  const s = w(e, t, n);
  return s == null ? void 0 : s.resources;
}
function ze(e, t, n = "status") {
  var o;
  const s = w(e, t, n);
  return ((o = s == null ? void 0 : s.settings) == null ? void 0 : o.colour) || void 0;
}
function H(e, t) {
  return t[e] ?? t["*"];
}
function je(e, t, n, s, o) {
  const i = v(""), r = v({}), a = g(() => !!i.value.trim()), u = g(
    () => {
      var S;
      const p = (
        // Check if the ticket type has a specific customization
        n.productCustomization[t.type] ?? // If not, check the current product customization
        n.productCustomization[s]
      ), h = (S = p == null ? void 0 : p.accessPolicy) == null ? void 0 : S.editTicketTitle, y = t.status, b = H(y, h ?? {});
      return (b == null ? void 0 : b.edit) ?? [];
    }
  ), c = g(() => {
    if (!o || !u.value.length)
      return !0;
    const { accessGranted: p } = P(
      u.value,
      o
    );
    return p;
  }), d = () => {
    const p = e.find((h) => !h.groupId);
    return p ? p.fields.every((h) => {
      var S;
      const y = (S = r.value[h.ref]) == null ? void 0 : S.state, b = (y == null ? void 0 : y.empty) ?? !0;
      return !(h.required && b);
    }) : !0;
  };
  C(r, () => {
    d();
  });
  const l = () => a && d(), m = v({
    valid: l(),
    title: i.value,
    dynamicState: r.value
  }), f = () => {
    m.value = {
      valid: l(),
      title: i.value,
      dynamicState: r.value
    };
  };
  return C(i, () => f()), C(r, () => f()), {
    title: i,
    allowTitleEdit: c,
    state: r,
    isTitleValid: a,
    validate: l,
    model: m
  };
}
function Le(e, t, n) {
  return {
    title: e,
    meta: Y(t, n),
    delegate: J(t),
    assignee: Q(t)
  };
}
function Y(e, t) {
  const n = (t == null ? void 0 : t.meta) ?? {};
  return Object.values(e).filter((s) => s.ref.startsWith("meta.")).forEach((s) => {
    const o = s.ref.split(".")[1];
    n[o] = s.state.empty ? null : s.value;
  }), n;
}
function J(e) {
  return Object.values(e).filter((t) => t.ref.startsWith("ticket.delegate.") && t.value).map((t) => t.value) ?? [];
}
function Q(e) {
  var t;
  return (t = e["ticket.assignee"]) == null ? void 0 : t.value;
}
function M(e) {
  const t = () => {
    const { firstName: u, lastName: c } = e.user;
    return u && c ? `${u} ${c}`.trim() : u ?? c ?? "";
  }, n = () => {
    const u = s();
    return u ? `https://teams.microsoft.com/l/chat/0/0?users=${u}` : void 0;
  }, s = () => e.user.email ? e.user.email : void 0, o = () => {
    var u;
    return ((u = e.team) == null ? void 0 : u.name) ?? e.user.departmentName;
  }, i = (u) => {
    const c = (d) => d.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/_/g, " ").split(" ").map(
      (l) => l.charAt(0).toUpperCase() + l.slice(1).toLowerCase()
    ).join(" ");
    return Object.entries(u).map(([d, l]) => ({
      label: c(d),
      value: l
    }));
  };
  return {
    displayName: t,
    microsoftTeamsLink: n,
    userDepartment: o,
    displayEmail: s,
    getPublicSettings: () => i(e.user.public ?? {}),
    getPrivateSettings: () => i(e.user.private ?? {})
  };
}
function ee(e, t) {
  return {
    teamName: () => {
      var o, i;
      return !e.resources || !Object.keys(e.resources).length ? e.name : (o = t(e.resources)) != null && o.name ? (i = t(e.resources)) == null ? void 0 : i.name : e.name;
    },
    teamDescription: () => {
      var o, i;
      return !e.resources || !Object.keys(e.resources).length ? e.description : (o = t(e.resources)) != null && o.description ? (i = t(e.resources)) == null ? void 0 : i.description : e.description;
    }
  };
}
function Ge(e) {
  const t = e.settings.mailCoachingPhase ?? [], n = e.settings.disableTimeline ?? [], s = e.settings.creationStatus, o = e.settings.deleteStatus ?? [], i = Object.keys(e.settings.status).filter((r) => r !== s).filter((r) => !o.includes(r));
  return { mailCoachingPhase: t, disableTimeline: n, activeStatus: i };
}
function $e(e) {
  const t = v(""), n = g(
    () => {
      var i, r;
      return (r = (i = e.settings) == null ? void 0 : i.status) == null ? void 0 : r[t.value];
    }
  ), s = g(
    () => {
      var i;
      return ((i = e.transitions) == null ? void 0 : i.filter(
        (r) => r.transitionFrom === t.value
      )) ?? [];
    }
  ), o = g(() => {
    var r, a;
    const i = (a = (r = n.value) == null ? void 0 : r.settings) == null ? void 0 : a.preferredNext;
    return s.value.find((u) => u.transitionTo === i);
  });
  return { fromStatus: t, available: s, preferred: o };
}
function te(e, t) {
  return { checkWorkgroupMembership: () => e.workgroups ? e.workgroups.some((s) => {
    var o;
    return (o = t.userTeamIds) == null ? void 0 : o.includes(s);
  }) : !0 };
}
const We = [
  "length",
  "mass",
  "volume",
  "temperature",
  "currency"
], ne = [
  "meter",
  "centimeter",
  "millimeter",
  "kilometer",
  "mile",
  "yard",
  "foot",
  "inch"
], se = [
  "kilogram",
  "gram",
  "milligram",
  "tonne",
  "ounce",
  "pound"
], re = [
  "cubic-meter",
  "liter",
  "milliliter",
  "us-fluid-ounce",
  "us-gallon",
  "us-pint"
], oe = [
  "kelvin",
  "celsius",
  "fahrenheit",
  "rankine"
], ie = [
  "us-dollar",
  "euro",
  "japanese-yen",
  "british-pound-sterling",
  "australian-dollar",
  "canadian-dollar",
  "swiss-franc",
  "chinese-yuan-renminbi",
  "hong-kong-dollar",
  "new-zealand-dollar",
  "swedish-krona",
  "south-korean-won",
  "singapore-dollar",
  "norwegian-krone",
  "mexican-peso",
  "indian-rupee",
  "russian-ruble",
  "south-african-rand",
  "brazilian-real",
  "turkish-lira"
], qe = [
  "si",
  "imperial",
  "us-customary"
], Ke = {
  length: ne,
  mass: se,
  volume: re,
  temperature: oe,
  currency: ie
}, B = {
  meter: {
    dimension: "length",
    system: "si",
    unit: "meter",
    symbol: "m",
    convert: {
      fromBase: (e) => e,
      toBase: (e) => e
    }
  },
  centimeter: {
    dimension: "length",
    system: "si",
    unit: "centimeter",
    symbol: "cm",
    convert: {
      fromBase: (e) => e * 100,
      toBase: (e) => e * 0.01
    }
  },
  millimeter: {
    dimension: "length",
    system: "si",
    unit: "millimeter",
    symbol: "mm",
    convert: {
      fromBase: (e) => e * 1e3,
      toBase: (e) => e * 1e-3
    }
  },
  kilometer: {
    dimension: "length",
    system: "si",
    unit: "kilometer",
    symbol: "km",
    convert: {
      fromBase: (e) => e * 1e-3,
      toBase: (e) => e * 1e3
    }
  },
  mile: {
    dimension: "length",
    system: "imperial",
    unit: "mile",
    symbol: "mi",
    convert: {
      fromBase: (e) => e * 6213712e-10,
      toBase: (e) => e * 1609.344
    }
  },
  yard: {
    dimension: "length",
    system: "imperial",
    unit: "yard",
    symbol: "yd",
    convert: {
      fromBase: (e) => e * 1.093613,
      toBase: (e) => e * 0.9144
    }
  },
  foot: {
    dimension: "length",
    system: "imperial",
    unit: "foot",
    symbol: "ft",
    convert: {
      fromBase: (e) => e * 3.28084,
      toBase: (e) => e * 0.3048
    }
  },
  inch: {
    dimension: "length",
    system: "imperial",
    unit: "inch",
    symbol: "in",
    convert: {
      fromBase: (e) => e * 39.37008,
      toBase: (e) => e * 0.0254
    }
  }
};
function ae(e, t) {
  const n = B[e.unit].convert.toBase(
    e.value
  );
  return B[t].convert.fromBase(n);
}
const I = {
  kilogram: {
    dimension: "mass",
    system: "si",
    unit: "kilogram",
    symbol: "kg",
    convert: {
      fromBase: (e) => e,
      toBase: (e) => e
    }
  },
  gram: {
    dimension: "mass",
    system: "si",
    unit: "gram",
    symbol: "g",
    convert: {
      fromBase: (e) => e * 1e3,
      toBase: (e) => e * 1e-3
    }
  },
  milligram: {
    dimension: "mass",
    system: "si",
    unit: "milligram",
    symbol: "mg",
    convert: {
      fromBase: (e) => e * 1e6,
      toBase: (e) => e * 1e-6
    }
  },
  tonne: {
    dimension: "mass",
    system: "si",
    unit: "tonne",
    symbol: "t",
    convert: {
      fromBase: (e) => e * 1e-3,
      toBase: (e) => e * 1e3
    }
  },
  ounce: {
    dimension: "mass",
    system: "imperial",
    unit: "ounce",
    symbol: "oz",
    convert: {
      fromBase: (e) => e * 35.27396,
      toBase: (e) => e * 0.02834952
    }
  },
  pound: {
    dimension: "mass",
    system: "imperial",
    unit: "pound",
    symbol: "lb",
    convert: {
      fromBase: (e) => e * 2.204623,
      toBase: (e) => e * 0.4535924
    }
  }
};
function ue(e, t) {
  const n = I[e.unit].convert.toBase(
    e.value
  );
  return I[t].convert.fromBase(n);
}
const A = {
  "cubic-meter": {
    dimension: "volume",
    system: "si",
    unit: "cubic-meter",
    symbol: "m³",
    convert: {
      fromBase: (e) => e,
      toBase: (e) => e
    }
  },
  liter: {
    dimension: "volume",
    system: "si",
    unit: "liter",
    symbol: "l",
    convert: {
      fromBase: (e) => e * 1e3,
      toBase: (e) => e * 1e-3
    }
  },
  milliliter: {
    dimension: "volume",
    system: "si",
    unit: "milliliter",
    symbol: "ml",
    convert: {
      fromBase: (e) => e * 1e6,
      toBase: (e) => e * 1e-6
    }
  },
  "us-fluid-ounce": {
    dimension: "volume",
    system: "us-customary",
    unit: "us-fluid-ounce",
    symbol: "fl oz",
    convert: {
      fromBase: (e) => e * 33814.13,
      toBase: (e) => e * 2957344e-11
    }
  },
  "us-gallon": {
    dimension: "volume",
    system: "us-customary",
    unit: "us-gallon",
    symbol: "gal",
    convert: {
      fromBase: (e) => e * 264.1729,
      toBase: (e) => e * 37854e-7
    }
  },
  "us-pint": {
    dimension: "volume",
    system: "us-customary",
    unit: "us-pint",
    symbol: "pt",
    convert: {
      fromBase: (e) => e * 2113.376,
      toBase: (e) => e * 4731765e-10
    }
  }
};
function ce(e, t) {
  const n = A[e.unit].convert.toBase(
    e.value
  );
  return A[t].convert.fromBase(n);
}
const R = {
  kelvin: {
    dimension: "temperature",
    system: void 0,
    unit: "kelvin",
    symbol: "K",
    convert: {
      fromBase: (e) => e,
      toBase: (e) => e
    }
  },
  celsius: {
    dimension: "temperature",
    system: "si",
    unit: "celsius",
    symbol: "°C",
    convert: {
      fromBase: (e) => e - 273.15,
      toBase: (e) => e + 273.15
    }
  },
  fahrenheit: {
    dimension: "temperature",
    system: "imperial",
    unit: "fahrenheit",
    symbol: "°F",
    convert: {
      fromBase: (e) => e * 9 / 5 - 459.67,
      toBase: (e) => 5 / 9 * (e + 459.67)
    }
  },
  rankine: {
    dimension: "temperature",
    system: void 0,
    unit: "rankine",
    symbol: "°R",
    convert: {
      fromBase: (e) => 9 / 5 * e,
      toBase: (e) => 5 / 9 * e
    }
  }
};
function le(e, t) {
  const n = R[e.unit].convert.toBase(
    e.value
  );
  return R[t].convert.fromBase(n);
}
function D(e) {
  switch (e) {
    case "length":
      return B;
    case "mass":
      return I;
    case "volume":
      return A;
    case "temperature":
      return R;
    default:
      throw new Error(`Unknown unit system '${e}'`);
  }
}
function Ve(e, t) {
  return D(e)[t];
}
function de(e) {
  switch (e) {
    case "length":
      return ae;
    case "mass":
      return ue;
    case "volume":
      return ce;
    case "temperature":
      return le;
    default:
      throw new Error(`Unknown unit converter '${e}'`);
  }
}
function Xe(e, t, n) {
  const o = new Intl.NumberFormat(void 0, {
    style: "decimal",
    signDisplay: "auto",
    minimumFractionDigits: n || 2,
    maximumFractionDigits: n || 2
  }).format(e.value);
  if (e.dimension === "currency")
    return `${t(`measure.unit.${e.unit}.symbol`)} ${o}`;
  const r = D(e.dimension)[e.unit];
  return `${o} ${(r == null ? void 0 : r.symbol) ?? ""}`;
}
function me(e, t) {
  const n = Math.sign(e.value), s = {
    dimension: e.dimension,
    unit: e.unit,
    value: Math.abs(e.value)
  }, o = de(s.dimension), i = Object.values(D(s.dimension)).filter(
    (a) => a.system === t
  );
  let r;
  if (i.forEach((a) => {
    const u = o(s, a.unit);
    (!r || u > 1 && r.value < 1 || u > 1 && u < r.value) && (r = {
      dimension: s.dimension,
      unit: a.unit,
      value: u
    });
  }), !r && t === "us-customary")
    return me(e, "imperial");
  if (r)
    return {
      dimension: r.dimension,
      unit: r.unit,
      value: r.value * (n || 1)
    };
}
const E = {
  ai: {
    similaritySearch: {
      hints: {
        duplicate: {
          prompt: {
            text: "You are an AI assistant helping to analyze and manage idea duplicates by identifying key similarities and providing actionable suggestions. Given two ideas that our system detected as duplicated, analyze their similarities and provide the top 4 highlights explaining why they are considered similar.Then, suggest ways to handle these duplicated ideas effectively but don't include any fields that contains Ids. Idea 1: {{ticketA}} Idea 2: {{ticketB}}",
            promptForUserLanguage: !0,
            placeholders: {
              ticketA: {
                description: "The main ticket, serving as the reference point or baseline for comparison",
                required: !0
              },
              ticketB: {
                description: "The ticket being compared against the main ticket to identify similarities",
                required: !0
              }
            }
          }
        },
        similar: {
          prompt: {
            text: "You are an AI assistant helping to analyze and manage idea duplicates by identifying key similarities and providing actionable suggestions. Given two ideas that our system detected as duplicated, analyze their similarities and provide the top 4 highlights explaining why they are considered similar.Then, suggest ways to handle these duplicated ideas effectively but don't include any fields that contains Ids. Idea 1: {{ticketA}} Idea 2: {{ticketB}}",
            promptForUserLanguage: !0,
            placeholders: {
              ticketA: {
                description: "The main ticket, serving as the reference point or baseline for comparison",
                required: !0
              },
              ticketB: {
                description: "The ticket being compared against the main ticket to identify similarities",
                required: !0
              }
            }
          }
        }
      }
    }
  }
};
function fe(e, t) {
  return [...new Set(e.map(t))].filter((n) => !!n);
}
function Ze(e) {
  return e.host.split(".")[0];
}
function He(e, t) {
  return t.find(
    (n) => n.toLowerCase() === e.toLowerCase()
  );
}
async function Ye(e, t, n) {
  const [s, o, i, r] = await Promise.allSettled([
    e.users.getUser(n, t),
    e.role.fetchActions(t),
    e.role.fetchRolesAndActions(n, t),
    e.organizations.fetchCurrentOrganization(t)
  ]);
  if (s.status === "rejected")
    return "ERROR_LOADING_USER";
  if (r.status === "rejected")
    return "ERROR_LOADING_CONTEXT";
  if (o.status === "rejected" || i.status === "rejected")
    return "ERROR_GENERIC";
  const a = r.value.enabledProducts, u = await Promise.allSettled(
    a.map((d) => e.workflow.fetchWorkflow(d, t))
  );
  if (u.some((d) => d.status === "rejected"))
    return "ERROR_GENERIC";
  const c = fe(i.value, (d) => d.role);
  return {
    user: s.value,
    roles: c,
    actions: o.value,
    organization: r.value,
    products: u.map(
      (d) => d.value
    )
  };
}
function Je(e) {
  var s;
  const t = e.organization.termsAndConditions.version ?? 0, n = ((s = e.user.termsAndConditions[e.organization.context]) == null ? void 0 : s.acceptedVersion) ?? 0;
  return {
    current: t,
    accepted: n
  };
}
function pe(e, t) {
  const n = !!e.products.find((o) => o.name === t), s = e.actions.includes(
    `${t.toUpperCase()}_USER_TICKET_READ`
  );
  return {
    productId: t,
    enabled: n,
    granted: s
  };
}
function Qe(e) {
  return Object.fromEntries(
    e.products.map((t) => [t.name, pe(e, t.name)])
  );
}
function ge(e, t) {
  var o, i, r, a;
  const n = (i = (o = e.delegates) == null ? void 0 : o.find(({ type: u }) => u === "topic")) == null ? void 0 : i.data;
  if (n)
    return t(n.resources).title;
  const s = (a = (r = e.delegates) == null ? void 0 : r.find(
    ({ type: u }) => ["workgroup", "team"].includes(u)
  )) == null ? void 0 : a.data;
  return s ? ee(s, t).teamName() : "";
}
function et(e, t, n) {
  var s, o, i;
  return {
    id: e.ticket.canonicalId,
    canonicalId: e.ticket.canonicalId,
    status: (s = n(Z(e.ticket.status, t))) == null ? void 0 : s.label,
    title: e.ticket.title,
    createdDate: new Date(e.ticket.createdDate).toLocaleDateString(),
    creator: e.creator ? M(e.creator).displayName() : "",
    creatorTeam: ((i = (o = e.creator) == null ? void 0 : o.team) == null ? void 0 : i.name) ?? "",
    assignee: e.assignee ? M(e.assignee).displayName() : "",
    delegate: ge(e, n),
    deadLine: e.ticket.deadLine ? new Date(e.ticket.deadLine).toLocaleDateString() : "",
    skills: [...e.ticket.skills ?? []],
    // skills are not part of the ticket
    lastModifiedDate: new Date(
      e.ticket.lastModifiedDate
    ).toLocaleDateString()
  };
}
function ve(e) {
  return e.toLowerCase().replace(/([-_][a-z])/g, (t) => t.toUpperCase()).replace(/[^a-zA-Z]/g, "");
}
function he(e) {
  return `${ve(e)}Reason`;
}
function tt(e) {
  var n;
  const t = (n = e.transitionDialog) == null ? void 0 : n.statusMessageRef;
  return t || he(e.transitionTo);
}
function ye(e, t) {
  return e.split(".").reduce((n, s) => n[s], t);
}
function be(e, t) {
  return e.map((n) => {
    var s;
    return ((s = t[n]) == null ? void 0 : s.label) ?? n;
  });
}
function nt(e, t, n) {
  const s = e.status, o = t.transitions.find(
    (u) => u.transitionFrom === s && u.transitionTo === n
  );
  if (!o)
    return {
      result: !1,
      reason: "invalid.transition"
    };
  const r = (o.requiredFields ?? []).filter(
    (u) => !ye(u, e)
  );
  if (r.length)
    return {
      result: !1,
      reason: "invalid.fields",
      args: r
    };
  const a = o.transitionDialog;
  return {
    result: !0,
    dialog: a != null && a.active ? a : void 0
  };
}
function st(e, t, n, s = {}, o) {
  var i;
  switch (e.reason) {
    case "invalid.transition":
      return o("error.invalidTransition", {
        fromStatus: t,
        toStatus: n
      }).toString();
    case "invalid.fields": {
      const r = ((i = be(e.args ?? [], s)) == null ? void 0 : i.join(`
 - `)) || "";
      return o("error.invalidFields", { fields: r }).toString();
    }
    default:
      return "";
  }
}
function rt(e) {
  var i;
  const t = e.settings.phases ?? [], n = Object.entries((i = e.settings) == null ? void 0 : i.status);
  function s(r) {
    return n.filter((a) => a[1].phase === r).map((a) => a[0]);
  }
  const o = [];
  return t.forEach((r) => {
    const a = s(r.name);
    a.length && o.push({
      phase: r.name,
      status: a
    });
  }), o;
}
function Se(e, t) {
  return Object.keys(t).forEach((n) => {
    t.hasOwnProperty(n) && (t[n] instanceof Object && e[n] instanceof Object ? e[n] = Se(e[n], t[n]) : e[n] = t[n]);
  }), e;
}
function U(e, t) {
  const n = { ...e };
  return Object.keys(t).forEach((s) => {
    t[s] && t[s] instanceof Object && !Array.isArray(t[s]) ? n[s] = U(e[s] || {}, t[s]) : n[s] = t[s];
  }), n;
}
function ot(e) {
  const t = g(
    () => U(E.ai, e || {})
  ), n = (c) => (
    // TODO: agent have a totally different structure, so just ignoring the agents now
    Object.entries(c).filter(([d]) => d !== "agents")
  ), s = (c) => c.flatMap(
    ([d, l]) => Object.entries(l).map(([m, f]) => ({
      featureKey: d,
      categoryKey: m,
      categoryValue: f
    }))
  ), o = (c) => c.flatMap(
    ({ featureKey: d, categoryKey: l, categoryValue: m }) => Object.entries(m).map(([f, p]) => ({
      feature: d,
      category: l,
      type: f,
      promptText: (p == null ? void 0 : p.prompt.text) || "",
      promptForUserLanguage: p == null ? void 0 : p.prompt.promptForUserLanguage,
      placeholders: (p == null ? void 0 : p.prompt.placeholders) || []
    }))
  ), i = g(
    () => o(s(n(t.value)))
  ), r = g(
    () => o(s(n(E.ai)))
  );
  function a(c) {
    return t.value[c];
  }
  function u(c) {
    return E.ai[c];
  }
  return {
    getAllAiFeatures: i,
    getAiFeatureByName: a,
    getAiDefaultFeatureByName: u,
    getDefaultAiFeatures: r
  };
}
function it(e) {
  const t = g(() => ["default", ...Object.keys(e.visibility.pages ?? {})]);
  return {
    availablePages: t,
    getAgentsForPages: (o, i) => {
      if (!t.value.some((c) => o.includes(c)))
        return [];
      const r = e.visibility, a = (r == null ? void 0 : r.default) ?? [], u = o.flatMap((c) => {
        var m, f, p;
        const d = ((m = r.pages[c]) == null ? void 0 : m.default) ?? [], l = i ? ((p = (f = r.pages[c]) == null ? void 0 : f.status) == null ? void 0 : p[i]) ?? [] : [];
        return [...d, ...l];
      });
      return Array.from(/* @__PURE__ */ new Set([...a, ...u]));
    },
    getPagesForAgent: (o) => {
      var a;
      const i = e.visibility, r = (a = i == null ? void 0 : i.default) != null && a.includes(o) ? ["default"] : [];
      return t.value.reduce((u, c) => {
        var d, l, m;
        return (m = (l = (d = i.pages) == null ? void 0 : d[c]) == null ? void 0 : l.default) != null && m.includes(o) && u.push(c), u;
      }, r);
    }
  };
}
function at(e, t, n, s, o = {}, i) {
  var l, m, f, p, h;
  if (i) {
    o.actor = ["creator", "assignee"];
    const y = {
      ...o
    };
    y.workgroups = [i];
    const { checkWorkgroupMembership: b } = te(
      y,
      s
    );
    return {
      accessGranted: b()
    };
  }
  const r = (
    // Check if the ticket type has a specific customization
    t.productCustomization[e.type] ?? // If not, check the current product customization
    t.productCustomization[n]
  ), c = /* Check if the ticket status has a specific policy */ ((f = (m = (l = r == null ? void 0 : r.accessPolicy) == null ? void 0 : l.ticketStatus) == null ? void 0 : m[e.status]) == null ? void 0 : f.edit) ?? // Else check the generic ticket policy
  ((h = (p = r == null ? void 0 : r.accessPolicy) == null ? void 0 : p.ticket) == null ? void 0 : h.edit) ?? (o ? [o] : []), { accessGranted: d } = P(c, s);
  return {
    accessGranted: d
  };
}
function ut(e) {
  const t = structuredClone(e), n = (l) => t.externalFields[l], s = (l, m) => {
    t.externalFields[l] = m;
  }, o = (l) => {
    t.externalFields.push(l);
  }, i = (l) => {
    t.externalFields.splice(l, 1);
  }, r = (l, m) => {
    var f;
    return (f = n(l)) == null ? void 0 : f.fields[m];
  }, a = (l, m, f) => {
    n(l).fields[m] = f;
  }, u = (l, m) => {
    n(l).fields.push(m);
  }, c = (l, m) => {
    n(l).fields.splice(m, 1);
  }, d = g(() => t);
  return {
    getGroup: n,
    updateGroup: s,
    removeGroup: i,
    addGroup: o,
    getField: r,
    updateField: a,
    addField: u,
    removeField: c,
    updatedForm: d
  };
}
function ct() {
  function t(i, r, a) {
    return i === r ? !0 : Math.abs(i - r) < a;
  }
  function n(i) {
    return Math.floor(i * 1e4) / 1e4;
  }
  function s(i, r = 100) {
    let a = i.reduce(
      (l, m) => l + m.share,
      0
    ), u = r - a, c = i.filter((l) => l.share === 0);
    if (u < 0 || t(u, 0, 0.01) && c.length > 0)
      return i.forEach((l) => {
        l.share = 0;
      }), s(i, r);
    c.length === 0 && u > 0 && (c = i);
    const d = u / c.length;
    if (c.forEach((l) => {
      l.share += n(d);
    }), !o(i, r)) {
      const l = i.reduce((p, h) => p + h.share, 0), f = (r - l) / i.length;
      i.forEach((p) => {
        p.share = n(p.share - f);
      });
    }
    return i;
  }
  function o(i, r) {
    const a = i.reduce((c, d) => c + d.share, 0), u = i.every((c) => c.share > 0);
    return a <= r && t(a, r, 0.01) && u;
  }
  return {
    distributeShares: s,
    checkShareDivide: o
  };
}
export {
  B as LengthUnitSystem,
  I as MassUnitSystem,
  We as SupportedDimension,
  qe as SupportedMeasurementSystem,
  ie as SupportedUnitCurrency,
  ne as SupportedUnitLength,
  se as SupportedUnitMass,
  Ke as SupportedUnitSystem,
  oe as SupportedUnitTemperature,
  re as SupportedUnitVolume,
  R as TemperatureUnitSystem,
  A as VolumeUnitSystem,
  me as bestFit,
  pe as checkProductClearance,
  Je as checkTermsAndConditions,
  ae as convertLength,
  ue as convertMass,
  le as convertTemperature,
  ce as convertVolume,
  U as deepMerge,
  Se as deepOverride,
  Xe as formatMeasurement,
  de as getConverter,
  ze as getStatusColor,
  Z as getStatusRes,
  Le as getTicketUpdateRequest,
  tt as getTransitionMessageRef,
  he as getTransitionMessageRefCompat,
  Ve as getUnitConfig,
  D as getUnitSystem,
  rt as getWorkflowPhases,
  Ye as loadApplicationScope,
  Fe as localGroupingKeyed,
  Qe as productAuthorizationReport,
  Ze as resolveContextDomain,
  He as resolveContextId,
  H as resolveStatusObject,
  et as ticketTableMapper,
  st as transitionMessage,
  nt as transitionValidation,
  ot as useAi,
  it as useAiAgents,
  Ee as useCanonical,
  Ge as useDeprecatedSpecialStatus,
  Re as useDropdownHelper,
  ut as useDynamicFieldConfiguration,
  De as useDynamicFieldsCompatibility,
  xe as useError,
  Me as useFileSize,
  Pe as useFirstCitizen,
  Ue as useMenuGrouping,
  we as useMustache,
  P as usePolicy,
  _e as useProducts,
  Ie as useSelection,
  ct as useShareDistributor,
  Be as useSortSelector,
  Ae as useSorting,
  ee as useTeam,
  je as useTicket,
  Ce as useTicketAttachment,
  Te as useTicketCard,
  at as useTicketPolicy,
  $e as useTransitions,
  M as useUser,
  Oe as useViewSettings,
  Ne as useWorkflowProductConfig,
  te as useWorkgroupPolicy
};
